import React from "react";
import PlaceholderPage from "../PlaceholderPage";

export default function StyleTransferPage() {
  return <PlaceholderPage title="Style Transfer" />;
}
